import filledstar from "../../assets/filled-star.svg";
import unfilledstar from "../../assets/unfilled-star.svg";

export default function FeedbackCell({
  onClick,
  questionNumber,
  focusedNumber,
  feedback,
  rating,
  question,
}) {
  // 0 empty star, 1 full star
  const starArr = [0, 0, 0, 0, 0];

  for (let i = 0; i < rating; i++) {
    starArr[i] = 1;
  }

  return (
    <button class="feedback-cell" onClick={onClick}>
      <div class="feedback-header">
        <p class="feedback-question-number">
          {questionNumber < 9
            ? `0${questionNumber + 1}`
            : `${questionNumber + 1}`}
        </p>
        <div class="stars">
          {starArr[0] === 1 ? (
            <img class="star" src={filledstar} />
          ) : (
            <img class="star" src={unfilledstar} />
          )}
          {starArr[1] === 1 ? (
            <img class="star" src={filledstar} />
          ) : (
            <img class="star" src={unfilledstar} />
          )}
          {starArr[2] === 1 ? (
            <img class="star" src={filledstar} />
          ) : (
            <img class="star" src={unfilledstar} />
          )}
          {starArr[3] === 1 ? (
            <img class="star" src={filledstar} />
          ) : (
            <img class="star" src={unfilledstar} />
          )}
          {starArr[4] === 1 ? (
            <img class="star" src={filledstar} />
          ) : (
            <img class="star" src={unfilledstar} />
          )}
        </div>
      </div>
      {focusedNumber() === questionNumber ? (
        <p style="color: #3b3b3b;">{question}</p>
      ) : (
        ``
      )}
      {focusedNumber() === questionNumber ? `${feedback}` : ``}
    </button>
  );
}
